import { CarouselConfigs } from './types'

export const carouselConfigs: CarouselConfigs = {
  dk: {
    onboarding: {
      hasReadMoreButton: false,
      hasTitle: true,
      screens: ['welcome', 'credibility', 'security', 'feedback'],
    },
  },
  se: {
    onboarding: {
      hasReadMoreButton: false,
      hasTitle: true,
      screens: ['welcome', 'credibility', 'security', 'feedback'],
    },
  },
  no: {
    onboarding: {
      hasReadMoreButton: false,
      hasTitle: true,
      screens: ['welcome', 'credibility', 'security', 'feedback'],
    },
  },
  fr: {
    onboarding: {
      hasReadMoreButton: false,
      hasTitle: true,
      screens: ['welcome', 'credibility', 'security', 'feedback'],
    },
  },
  es: {
    onboarding: {
      hasReadMoreButton: false,
      hasTitle: true,
      screens: ['welcome', 'credibility', 'security', 'feedback'],
    },
  },
}
